import React, { useEffect, useMemo } from 'react';
import './ViewClassComponent.css';
import { ShoppingCartOutlined, StarFilled } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useCart } from '../../Utilities/useCart';
import play from '../../Assets/play.png';

function ViewClassComponent({ classData }) {
  const navigate = useNavigate();
  const { cart, addToCart, isInCart } = useCart();

  // Log classData to see all available properties
  useEffect(() => {
    console.log('Class UID:', classData?.id);
  }, [classData]);

  const handleViewClass = (classId) => {
    navigate(`/class/${classId}`);
  };

  const handleAddToCart = () => {
    if (!isInCart(classData.id)) {
      const cartItem = {
        id: classData.id,
        title: classData.title,
        instructor: classData.instructor,
        price: classData.cost,
        thumbnail: classData.thumbnail,
        education_class: classData.education_class,
        quantity: 1,
        type: 'class',
        class_uid: classData.class_uid || classData.id, // Use class_uid if available, fallback to id
      };
      addToCart(cartItem);
    } else {
      navigate('/cart', { state: { classId: classData.class_uid || classData.id } });
    }
  };

  // Generate Thumbnail Source - Updated to use UID format
  const thumbnailSrc = useMemo(() => {
    if (classData.id) {
      const newUrl = `https://beyondschools.co.tz:8443/api/Public/get-class-thumbnail/${classData.id}`;
      console.log('Using new URL format:', newUrl);
      return newUrl;
    }
  },);

  const formatDuration = (totalSeconds) => {
    if (!totalSeconds) return '0m';
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const parts = [];
    if (hours > 0) parts.push(`${hours}h`);
    if (minutes > 0 || hours === 0) parts.push(`${minutes}m`);
    return parts.join(' ');
  };

  return (
    <div className='view-class-container'>
      <div className="class-image" onClick={() => handleViewClass(classData?.id)} style={{ backgroundImage: `url(${thumbnailSrc})` }}>
        <img src={play} alt="Play Icon" className="play-toggle" />
      </div>

      <div className='view-class-details'>
        <div className='teacher-price'>
          <span className='teacher-name'>{classData?.instructor || 'Instructor Name Not Available'}</span>
          <span className='price-value'>Tsh {classData?.cost?.toLocaleString() || '0'}</span>
        </div>

        <p className='class-view-title'>{classData?.title || 'Class Title Not Available'}</p>

        <div className='class-view-description-container'>
          <div className="single-star-rating">
            <StarFilled className="star-icon" />
            <span className="rating-value">4.5</span>
          </div>

          <div className="single-star-rating">
            <span className="rating-value">{classData?.education_class}</span>
          </div>
        </div>

        <div className='teacher-price'>
          <div className='class-view-watch'>
            <span className='student-number'>{classData?.enrolled || '0'} students</span>
            <span className='student-number'>
              {formatDuration(classData?.duration)}
            </span>
          </div>

          <div 
            className={`add-to-cart-container ${isInCart(classData.id) ? 'in-cart' : ''}`} 
            onClick={handleAddToCart}
          >
            <ShoppingCartOutlined className='shopping-view-icon'/>
            <span className='add-to-cart-text'>
              {isInCart(classData.id) ? 'View Cart' : 'Add to Cart'}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ViewClassComponent;